module.exports = __webpack_public_path__ + "img/au-sa.d2f2f77e.svg";